import React from "react";
import { Fragment, useState } from "react";
import { Dialog, Menu, Transition, Disclosure } from "@headlessui/react";
import {
  Link,
  Navigate,
  useSearchParams,
  useLocation,
  useParams,
} from "react-router-dom";
import mainLogo from "../mglogo.png";
import {
  BellIcon,
  CalendarIcon,
  ChartBarIcon,
  FolderIcon,
  HomeIcon,
  InboxIcon,
  PencilIcon,
  LinkIcon,
  PaperClipIcon,
  MenuAlt2Icon,
  ShoppingBagIcon,
  UsersIcon,
  XIcon,
  ClipboardIcon,
  ShoppingCartIcon,
  DocumentIcon,
  TemplateIcon,
  XCircleIcon,
} from "@heroicons/react/outline";
import {
  CheckCircleIcon,
  SearchIcon,
  DotsVerticalIcon,
  ExclamationIcon,
  ColorSwatchIcon,
  CogIcon,
} from "@heroicons/react/solid";
import axios from "axios";



function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

class Invoiceview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: false,
      setSidebarOpen: false,
      showmsg: false,
      logoutRedirect: false,
      sidebarOpen: false,
      setSidebarOpen: false,
      showmsgsaveasSent: false,
      logoutRedirect: false,
      success: false,
      commonGSTvalue: 0,
      error_list: [],
      invoiceDetails: [],
      customerDetails: [],
      brachDetails: [],
      billingAddress: [],
      items: [],
      totalTaxamount: [],
      branchState: [],
      branchCountry: [],
      cutomerState: [],
      cutomerCountry: [],
      invocieId: [],
      paymentList: [],
      placeofSupply: "",
      deletealartmsg: false,
      recoerdpaymentredirect: false,
      loader: "",
      overLay: "",
      icon: "",
      InvoicerecordpaymentEdit:"/crm/filterby/InvoicerecordpaymentEdit/",
      message: "Successfully Saved",
      invoiceEditlink:"/crm/filterby/InvoiceEdit/",
    };
  }

  setLoaderFunction = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "fixed inset-0 bg-black/30",
    });
  };
  closeLoaderFuncion = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "",
    });
  };
  close = async (e) => {
    this.setState({ sidebarOpen: false });
  };
  open = async (e) => {
    console.log("open")
    this.setState({ sidebarOpen: true });
  };

  componentDidUpdate(prevProps, prevState, snapshot){
   
    if(this.state.deleteRedirect==true){
      this.setState({deleteRedirect:false});
      const token = localStorage.getItem("token");
      const { id } = this.props.params;
      this.setState({ invocieId: id });
      const ress = axios
        .get("public/api/invoice/edit/" + id, {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((ress) => {
          this.setState({
            invoiceDetails: ress.data.invoice,
            customerDetails: ress.data.invoice.customer_details_for_edit,
            brachDetails: ress.data.invoice.branch,
            branchState: ress.data.invoice.branch.state_union_territory,
            billingAddress:
              ress.data.invoice.customer_details_for_edit.customer_address,
            cutomerState:
              ress.data.invoice.customer_details_for_edit.customer_address
                .billing_state_name,
            cutomerCountry:
              ress.data.invoice.customer_details_for_edit.customer_address
                .billing_country_name,
            items: ress.data.invoice.invoice_item,
            totalTaxamount: ress.data.invoice.item_tax_total,
            commonGSTvalue: ress.data.invoice.invoice_item[0].gst_igst_common_value,
            loader: "",
            placeofSupply:
              ress.data.invoice.customer_details_for_edit.customer_other_detail
                .place_of_supply_name,
            paymentList: ress.data.invoice.customer_payment_received,
          });
          
        });
  }}

  componentDidMount() {
    this.setLoaderFunction();
    const token = localStorage.getItem("token");
    const { id } = this.props.params;
    this.setState({ invocieId: id });
    const ress = axios
      .get("public/api/invoice/edit/" + id, {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((ress) => {
        this.setState({
          invoiceDetails: ress.data.invoice,
          customerDetails: ress.data.invoice.customer_details_for_edit,
          brachDetails: ress.data.invoice.branch,
          branchState: ress.data.invoice.branch.state_union_territory,
          billingAddress:
            ress.data.invoice.customer_details_for_edit.customer_address,
          cutomerState:
            ress.data.invoice.customer_details_for_edit.customer_address
              .billing_state_name,
          cutomerCountry:
            ress.data.invoice.customer_details_for_edit.customer_address
              .billing_country_name,
          items: ress.data.invoice.invoice_item,
          totalTaxamount: ress.data.invoice.item_tax_total,
          commonGSTvalue: ress.data.invoice.invoice_item[0].gst_igst_common_value,
          loader: "",
          placeofSupply:
            ress.data.invoice.customer_details_for_edit.customer_other_detail
              .place_of_supply_name,
          paymentList: ress.data.invoice.customer_payment_received,
        });
        
      });
      
    this.closeLoaderFuncion();
  }

  delete = async (e) => {
    this.setState({ deletealartmsg: true });
    this.setState({ cryptKey: e });
  };

  haldleDelete = async (e) => {
    if (this.state.deletealartmsg) {
      const token = localStorage.getItem("token");
      let id = this.state.cryptKey;
      //const id=this.setState({cryptKey:e});
      const resDelete = axios
        .get("public/api/customer/payment/received/delete/" + id, {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((resDelete) => {
          if (resDelete.data.success) {
            this.setState({ deleteRedirect: true });
            this.setState({ deletealartmsg: false });
          }
        });
    }
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  recordPayment = (e) => {
    this.setState({ recoerdpaymentredirect: true });
  };

  pdfDownload = (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token");
    const { id } = this.props.params;

    const resspdf = axios
      .get("public/api/invoice/pdf/" + id, {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        responseType: "blob",
      })
      .then((resspdf) => {
        const url = window.URL.createObjectURL(new Blob([resspdf.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          this.state.invoiceDetails.transaction_series_number + ".pdf"
        ); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  };

  saveassent = async (e) => {
    const token = localStorage.getItem("token");
    const { id } = this.props.params;
    const ressaveassent = axios
      .get("public/api/invoice/mark/as/sent/" + id, {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((ressaveassent) => {
        this.setState({ icon: ressaveassent.data.success });
        if (ressaveassent.data.success) {
          this.setState({ message: "Successfully Saved" });
          this.setState({ showmsg: true });
          setTimeout(
            function () {
              this.setState({ showmsg: false }); //After 1 second, set render to true
              this.setState({ message: "" });
            }.bind(this),
            2000
          );
        } else {
          if (ressaveassent.data.data != undefined) {
            this.state.error_list = ressaveassent.data.data;
            this.setState({ error_list: this.state.error_list });
          } else {
            this.state.error_list = null;
            this.setState({ error_list: this.state.error_list });
            this.state.message = ressaveassent.data.message;
            this.setState({ message: this.state.message });
            this.setState({ showmsg: true });

            setTimeout(
              function () {
                this.setState({ showmsg: false });
              }.bind(this),
              1000
            );
          }
        }
      });
  };

  invoiceViewNullfunction = (e) => {
    if (e == null) {
      return " ";
    } else {
      return e;
    }
  };

  invoiceViewNullfunctionState = (e) => {
    if (e == null) {
      return " ";
    } else {
      if (e.name == null) {
        return "";
      } else {
        return e.name;
      }
    }
  };

  invoiceViewNullfunctionCountry = (e) => {
    if (e == null) {
      return " ";
    } else {
      if (e.name == null) {
        return "";
      } else {
        return e.name;
      }
    }
  };

  invoiceViewNullfunctionTin = (e) => {
    if (e == null) {
      return " ";
    } else {
      if (e.tin_number == null) {
        return "";
      } else {
        return e.tin_number;
      }
    }
  };
  //Logout function

  logout = async (e) => {
    e.preventDefault();
    var token = localStorage.getItem("token");

    const res = await axios.get("public/api/logout", {
      headers: {
        authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    //console.log(res);

    if (res.data.success) {
      localStorage.removeItem("token");

      //Start the timer
      this.setState({ logoutRedirect: true }); //After 1 second, set render to true
    }
  };

  //Logout function

  render() {
    if (this.state.recoerdpaymentredirect) {
      const { id } = this.props.params;
      this.state.recoerdpaymentredirect=false;
      this.setState({recoerdpaymentredirect:this.state.recoerdpaymentredirect});

      return <Navigate to={"/filterby/Invoicerecordpayment/" + id} />;
    }

    let token = localStorage.getItem("token");

    if (token == null) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.logoutRedirect) {
      return <Navigate to={"/Login"} />;
    }

    
   

    return (
      <>
        {/*
            This example requires updating your template:
    
            ```
            <html class="h-full bg-gray-100">
            <body class="h-full">
            ```
          */}
        <div>
          <div className={this.state.overLay} aria-hidden="true" />
          

          {/* Static sidebar for desktop */}
       
          
                  <div class="flex flex-row">
                    <div class="basis-1/4">
                      {" "}
                      <h1 className="text-2xl font-semibold text-gray-900">
                        View Invoice
                      </h1>
                    </div>
                    <div class="basis-1/4"></div>
                    <div class="basis-1/4"></div>
                    <div class="basis-1/4 place-content-end">
                      <Menu
                        as="div"
                        className="ml-3 relative inline-block text-left"
                      >
                        <div>
                          <Menu.Button className="-my-2 p-2 rounded-full bg-white flex items-center text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500">
                            <span className="sr-only">Open options</span>
                            <DotsVerticalIcon
                              className="h-5 w-5"
                              aria-hidden="true"
                            />
                          </Menu.Button>
                        </div>

                        <Transition
                          as={Fragment}
                          enter="transition ease-out duration-100"
                          enterFrom="transform opacity-0 scale-95"
                          enterTo="transform opacity-100 scale-100"
                          leave="transition ease-in duration-75"
                          leaveFrom="transform opacity-100 scale-100"
                          leaveTo="transform opacity-0 scale-95"
                        >
                          <Menu.Items className="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                            <div className="py-1">
                              <Menu.Item>
                                {({ active }) => (
                                  <a
                                    href="#"
                                    onClick={this.pdfDownload}
                                    target="__blank"
                                    className={classNames(
                                      active
                                        ? "bg-gray-100 text-gray-900"
                                        : "text-gray-700",
                                      "flex justify-between px-4 py-2 text-sm"
                                    )}
                                  >
                                    <span>Download Pdf</span>
                                  </a>
                                )}
                              </Menu.Item>
                              <Menu.Item>
                                {({ active }) => (
                                  <a
                                    href={
                                      this.state.invoiceEditlink+ this.state.invocieId
                                    }
                                    className={classNames(
                                      active
                                        ? "bg-gray-100 text-gray-900"
                                        : "text-gray-700",
                                      "flex justify-between px-4 py-2 text-sm"
                                    )}
                                  >
                                    <span>Edit</span>
                                  </a>
                                )}
                              </Menu.Item>
                              <Menu.Item>
                                {({ active }) => (
                                  <button
                                    type="button"
                                    onClick={this.recordPayment}
                                    className={classNames(
                                      active
                                        ? "bg-gray-100 text-gray-900"
                                        : "text-gray-700",
                                      "w-full flex justify-between px-4 py-2 text-sm"
                                    )}
                                  >
                                    <span>Record Payment</span>
                                  </button>
                                )}
                              </Menu.Item>
                              <Menu.Item>
                                {({ active }) => (
                                  <a
                                    href="#"
                                    onClick={this.saveassent}
                                    className={classNames(
                                      active
                                        ? "bg-gray-100 text-gray-900"
                                        : "text-gray-700",
                                      "flex justify-between px-4 py-2 text-sm"
                                    )}
                                  >
                                    <span>Save as Sent</span>
                                  </a>
                                )}
                              </Menu.Item>
                            </div>
                          </Menu.Items>
                        </Transition>
                      </Menu>
                    </div>
                  </div>
                </div>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                  {/* Replace with your content */}

                  <div className="hidden sm:block" aria-hidden="true">
                    <div className="py-5">
                      <div className="border-t border-gray-200" />
                    </div>
                  </div>

                  <div className="mt-10 sm:mt-0">
                    <div className={`md:grid md:gap-6 ${this.state.loader}`}>
                      <div className="mt-5 md:mt-0 md:col-span-2">
                        <form onSubmit={this.udpateItem}>
                          <div className="shadow overflow-hidden sm:rounded-md">
                            <div className="px-4 py-5 bg-white sm:p-6">
                              <div className="px-4 sm:px-6 lg:px-8">
                                <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
                                  <div className="sm:col-span-1">
                                    <dt className="text-sm font-medium text-gray-500">
                                      {" "}
                                      {this.state.brachDetails.name}
                                    </dt>
                                    <dd className="mt-1 text-sm text-gray-900">
                                      
                                      {" "}
                                      {this.state.brachDetails.street_one}
                                    </dd>
                                    <dd className="mt-1 text-sm text-gray-900">
                                      {" "}
                                      {this.state.brachDetails.street_two}
                                    </dd>
                                    <dd className="mt-1 text-sm text-gray-900">
                                      {this.state.brachDetails.city},
                                      {this.state.branchState.name}{" "}
                                      {this.state.brachDetails.zip_postal_code}
                                    </dd>
                                    <dd className="mt-1 text-sm text-gray-900">
                                      {this.state.branchCountry.name}
                                    </dd>

                                    <dd className="mt-1 text-sm text-gray-900">
                                      GSTIN {this.state.brachDetails.gstin}
                                    </dd>
                                  </div>
                                  <div className="sm:col-span-1 text-right	">
                                    <dt className="text-sm font-medium text-gray-500">
                                      INVOICE
                                    </dt>
                                    <dd className="mt-1 text-sm text-gray-900">
                                      {
                                        this.state.invoiceDetails
                                          .transaction_series_number
                                      }
                                    </dd>
                                    <dd className="mt-1 text-sm text-gray-900">
                                      Balance Due
                                    </dd>
                                    <dd className="mt-1 text-sm text-gray-900">
                                      ₹ {this.state.invoiceDetails.balance_due}
                                    </dd>
                                  </div>
                                  <div className="sm:col-span-1">
                                    <dt className="text-sm font-medium text-gray-500">
                                      {" "}
                                      Bill To
                                    </dt>
                                    <dd className="mt-1 text-sm text-gray-900">
                                      {this.state.customerDetails.customer_display_name}
                                    </dd>
                                    <dd className="mt-1 text-sm text-gray-900">
                                      {this.invoiceViewNullfunction(
                                        this.state.billingAddress
                                          .billing_address_street_one
                                      )}
                                    </dd>
                                    <dd className="mt-1 text-sm text-gray-900">
                                      {this.invoiceViewNullfunction(
                                        this.state.billingAddress
                                          .billing_address_street_two
                                      )}
                                    </dd>
                                    <dd className="mt-1 text-sm text-gray-900">
                                      {this.invoiceViewNullfunction(
                                        this.state.billingAddress.billing_city
                                      )}
                                      ,
                                      {this.invoiceViewNullfunctionState(
                                        this.state.cutomerState
                                      )}{" "}
                                      {this.invoiceViewNullfunction(
                                        this.state.billingAddress
                                          .billing_zip_code
                                      )}{" "}
                                    </dd>
                                    <dd className="mt-1 text-sm text-gray-900">
                                      {this.invoiceViewNullfunctionCountry(
                                        this.state.cutomerCountry
                                      )}
                                    </dd>
                                    <dd className="mt-1 text-sm text-gray-900">
                                      GSTIN{" "}
                                      {this.invoiceViewNullfunction(
                                        this.state.customerDetails.gstin_uin
                                      )}
                                    </dd>
                                  </div>
                                  <div className="sm:col-span-1 text-right	">
                                    <dt className="text-sm font-medium text-gray-500">
                                      Invoice Date :{" "}
                                      {this.state.invoiceDetails.invoice_date}
                                    </dt>
                                    <dd className="mt-1 text-sm text-gray-900">
                                      Terms : Due on Receipt
                                    </dd>
                                    <dd className="mt-1 text-sm text-gray-900">
                                      Due Date :{" "}
                                      {this.state.invoiceDetails.due_date}
                                    </dd>
                                    <dd className="mt-1 text-sm text-gray-900"></dd>
                                  </div>

                                  <div className="sm:col-span-2">
                                    <dt className="text-sm font-medium text-gray-500">
                                      Place Of Supply:{" "}
                                      {this.invoiceViewNullfunctionCountry(
                                        this.state.placeofSupply
                                      )}
                                      (
                                      {this.invoiceViewNullfunctionTin(
                                        this.state.placeofSupply
                                      )}
                                      )
                                    </dt>
                                    <dd className="mt-1 text-sm text-gray-900"></dd>
                                  </div>
                                </dl>
                                <div className="sm:flex sm:items-center">
                                  <div className="sm:flex-auto">
                                    <h1 className="text-xl font-semibold text-gray-900"></h1>
                                    <p className="mt-2 text-sm text-gray-700">
                                      <time dateTime="2022-08-01"></time>
                                      <time dateTime="2022-08-31"></time>
                                    </p>
                                  </div>
                                  <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none"></div>
                                </div>
                                <div className="-mx-4 mt-8 flex flex-col sm:-mx-6 md:mx-0">
                                  <table className="min-w-full divide-y divide-gray-300">
                                    <thead>
                                      <tr>
                                        <th
                                          scope="col"
                                          className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 md:pl-0"
                                        >
                                          Item & Description
                                        </th>
                                        <th
                                          scope="col"
                                          className="hidden py-3.5 px-3 text-right text-sm font-semibold text-gray-900 sm:table-cell"
                                        >
                                          HSN/SAC
                                        </th>
                                        <th
                                          scope="col"
                                          className="hidden py-3.5 px-3 text-right text-sm font-semibold text-gray-900 sm:table-cell"
                                        >
                                          Qty
                                        </th>
                                        <th
                                          scope="col"
                                          className="py-3.5 pl-3 pr-4 text-right text-sm font-semibold text-gray-900 sm:pr-6 md:pr-0"
                                        >
                                          Rate
                                        </th>
                                        {this.state.commonGSTvalue == 2 ? (
                                          <th
                                            scope="col"
                                            className="hidden py-3.5 px-3 text-right text-sm font-semibold text-gray-900 sm:table-cell"
                                          >
                                            IGST
                                          </th>
                                        ) : (
                                          ""
                                        )}

                                        {this.state.commonGSTvalue == 3 ? (
                                          <>
                                            <th
                                              scope="col"
                                              className="hidden py-3.5 px-3 text-right text-sm font-semibold text-gray-900 sm:table-cell"
                                            >
                                              CGST
                                            </th>
                                            <th
                                              scope="col"
                                              className="hidden py-3.5 px-3 text-right text-sm font-semibold text-gray-900 sm:table-cell"
                                            >
                                              SGST
                                            </th>
                                          </>
                                        ) : (
                                          ""
                                        )}

                                        <th
                                          scope="col"
                                          className="py-3.5 pl-3 pr-4 text-right text-sm font-semibold text-gray-900 sm:pr-6 md:pr-0"
                                        >
                                          Amount
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {this.state.items.map((item) => (
                                        <tr
                                          key={item.id}
                                          className="border-b border-gray-200"
                                        >
                                          <td className="py-4 pl-4 pr-3 text-sm sm:pl-6 md:pl-0">
                                            <div className="font-medium text-gray-900">
                                              {item.name}
                                              <br />
                                              <span className="text-gray-500 text-sm">
                                                {item.description}
                                              </span>
                                            </div>
                                            <div className="mt-0.5 text-gray-500 sm:hidden"></div>
                                          </td>

                                          <td className="hidden py-4 px-3 text-right text-sm text-gray-500 sm:table-cell">
                                            {item.hsn_code}
                                          </td>
                                          <td className="hidden py-4 px-3 text-right text-sm text-gray-500 sm:table-cell">
                                            {item.quantity}
                                          </td>
                                          <td className="py-4 pl-3 pr-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                            {item.rate}
                                          </td>

                                          {this.state.commonGSTvalue === 2 ? (
                                            <td className="py-4 pl-3 pr-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                              <div className="font-medium text-gray-900">
                                                {item.igst_amount},{" "}
                                                <span className="text-xs break-after-column	">
                                                  {item.igst_percentage}%
                                                </span>
                                              </div>
                                              <div className="mt-0.5 text-gray-500 sm:hidden"></div>
                                            </td>
                                          ) : (
                                            ""
                                          )}
                                          {this.state.commonGSTvalue === 3 ? (
                                            <>
                                              <td className="py-4 pl-3 pr-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                                <div className="font-medium text-gray-900">
                                                  {item.cgst_amount}, <br />
                                                  {item.cgst_percentage}%
                                                </div>
                                                <div className="mt-0.5 text-gray-500 sm:hidden"></div>
                                              </td>
                                              <td className="py-4 pl-3 pr-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                                <div className="font-medium text-gray-900">
                                                  {item.sgst_amount}, <br />
                                                  {item.sgst_percentage}%
                                                </div>
                                                <div className="mt-0.5 text-gray-500 sm:hidden"></div>
                                              </td>
                                            </>
                                          ) : (
                                            ""
                                          )}

                                          <td className="py-4 pl-3 pr-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                            {item.amount}
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                    <tfoot>
                                      <tr>
                                        <th
                                          scope="row"
                                          colSpan={5}
                                          className="hidden pl-6 pr-3 pt-6 text-right text-sm font-normal text-gray-500 sm:table-cell md:pl-0"
                                        >
                                          Subtotal
                                        </th>
                                        <th
                                          scope="row"
                                          className="pl-4 pr-3 pt-6 text-left text-sm font-normal text-gray-500 sm:hidden"
                                        >
                                          Subtotal
                                        </th>
                                        <td className="pl-3 pr-4 pt-6 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                          {this.state.invoiceDetails.sub_total}
                                        </td>
                                      </tr>
                                      <tr>
                                        <th
                                          scope="row"
                                          colSpan={5}
                                          className="hidden pl-6 pr-3 pt-4 text-right text-sm font-normal text-gray-500 sm:table-cell md:pl-0"
                                        >
                                          Total Tax
                                        </th>
                                        <th
                                          scope="row"
                                          className="pl-4 pr-3 pt-4 text-left text-sm font-normal text-gray-500 sm:hidden"
                                        >
                                          Tax
                                        </th>
                                        {this.state.commonGSTvalue == 2 ? (
                                          <td className="pl-3 pr-4 pt-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                            {
                                              this.state.totalTaxamount
                                                .totalIgstAmount
                                            }
                                          </td>
                                        ) : (
                                          ""
                                        )}
                                        {this.state.commonGSTvalue == 3 ? (
                                          <td className="pl-3 pr-4 pt-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                            {
                                              this.state.totalTaxamount
                                                .totalCgstSgst
                                            }
                                          </td>
                                        ) : (
                                          ""
                                        )}
                                      </tr>

                                      <tr>
                                        <th
                                          scope="row"
                                          colSpan={5}
                                          className="hidden pl-6 pr-3 pt-4 text-right text-sm font-semibold text-gray-900 sm:table-cell md:pl-0"
                                        >
                                          Total
                                        </th>
                                        <th
                                          scope="row"
                                          className="pl-4 pr-3 pt-4 text-left text-sm font-semibold text-gray-900 sm:hidden"
                                        >
                                          Total
                                        </th>
                                        <td className="pl-3 pr-4 pt-4 text-right text-sm font-semibold text-gray-900 sm:pr-6 md:pr-0">
                                          {this.state.invoiceDetails.total}
                                        </td>
                                      </tr>
                                      <tr>
                                        <th
                                          scope="row"
                                          colSpan={5}
                                          className="hidden pl-6 pr-3 pt-4 text-right text-sm font-semibold text-gray-900 sm:table-cell md:pl-0"
                                        >
                                          Balance Due
                                        </th>
                                        <th
                                          scope="row"
                                          className="pl-4 pr-3 pt-4 text-left text-sm font-semibold text-gray-900 sm:hidden"
                                        >
                                          Balance Due
                                        </th>
                                        <td className="pl-3 pr-4 pt-4 text-right text-sm font-semibold text-gray-900 sm:pr-6 md:pr-0">
                                          {
                                            this.state.invoiceDetails
                                              .balance_due
                                          }
                                        </td>
                                      </tr>
                                    </tfoot>
                                  </table>
                                </div>
                              </div>
                            </div>

                            <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                              <div className="col-span-6 sm:col-span-6 lg:col-span-6">
                                <div className="-mx-4 mt-8 flex flex-col sm:-mx-6 md:mx-0">
                                  <table
                                    className={`min-w-full divide-y divide-gray-300 ${this.state.loader}`}
                                  >
                                    <thead className="bg-gray-50">
                                      <tr>
                                        <th
                                          scope="col"
                                          className="py-3 pl-4 pr-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500 sm:pl-6"
                                        >
                                          Date
                                        </th>

                                        <th
                                          scope="col"
                                          className="px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500"
                                        >
                                          Payment #
                                        </th>
                                        <th
                                          scope="col"
                                          className="px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500"
                                        >
                                          Reference#
                                        </th>
                                        <th
                                          scope="col"
                                          className="px-3 py-3 text-left  text-xs font-medium uppercase tracking-wide text-gray-500"
                                        >
                                          Payment Mode
                                        </th>
                                        <th
                                          scope="col"
                                          className="px-3 py-3 text-left  text-xs font-medium uppercase tracking-wide text-gray-500"
                                        >
                                          Amount
                                        </th>
                                        <th
                                          scope="col"
                                          className="px-3 py-3 text-left  text-xs font-medium uppercase tracking-wide text-gray-500"
                                        >
                                          Action
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody className="divide-y divide-gray-200 bg-white">
                                      {this.state.paymentList.map((person) => (
                                        <tr key={person.id}>
                                          <td className="whitespace-nowrap text-left px-3 py-4 text-sm text-gray-500">
                                            {person.payment_date}
                                          </td>
                                          <td className="whitespace-nowrap text-left px-3 py-4 text-sm text-gray-500">
                                            {person.transaction_series_number}
                                          </td>
                                          <td className="whitespace-nowrap text-left px-3 py-4 text-sm text-gray-500">
                                            {person.reference}
                                          </td>
                                          <td className="whitespace-nowrap text-left px-3 py-4 text-sm text-gray-500">
                                            {person.payment_mode.name}
                                          </td>
                                          <td className="whitespace-nowrap text-left px-3 py-4 text-sm text-gray-500">
                                            {person.amount_received}
                                          </td>
                                          <td className="whitespace-nowrap text-left px-3 py-4 text-sm text-gray-500">
                                            <a
                                              href={
                                                this.state.InvoicerecordpaymentEdit+
                                                person.id_crypt
                                              }
                                            >
                                              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 cursor-pointer">
                                                Edit
                                              </span>
                                            </a>
                                            <span
                                              onClick={() =>
                                                this.delete(person.id_crypt)
                                              }
                                              className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-pink-100 text-pink-800 cursor-pointer"
                                            >
                                              Delete
                                            </span>
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  {/*DeleteAlert */}
                  <Transition.Root
                    show={this.state.deletealartmsg}
                    as={Fragment}
                  >
                    <Dialog
                      as="div"
                      className="fixed z-10 inset-0 overflow-y-auto"
                      onClose={() => this.setState({ deletealartmsg: false })}
                    >
                      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                        <Transition.Child
                          as={Fragment}
                          enter="ease-out duration-300"
                          enterFrom="opacity-0"
                          enterTo="opacity-100"
                          leave="ease-in duration-200"
                          leaveFrom="opacity-100"
                          leaveTo="opacity-0"
                        >
                          <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                        </Transition.Child>

                        {/* This element is to trick the browser into centering the modal contents. */}
                        <span
                          className="hidden sm:inline-block sm:align-middle sm:h-screen"
                          aria-hidden="true"
                        >
                          &#8203;
                        </span>
                        <Transition.Child
                          as={Fragment}
                          enter="ease-out duration-300"
                          enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                          enterTo="opacity-100 translate-y-0 sm:scale-100"
                          leave="ease-in duration-200"
                          leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                          leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                          <div className="relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
                            <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                              <button
                                type="button"
                                className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                onClick={() =>
                                  this.setState({ deletealartmsg: false })
                                }
                              >
                                <span className="sr-only">Close</span>
                                <XIcon className="h-6 w-6" aria-hidden="true" />
                              </button>
                            </div>
                            <div className="sm:flex sm:items-start">
                              <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                                <ExclamationIcon
                                  className="h-6 w-6 text-red-600"
                                  aria-hidden="true"
                                />
                              </div>
                              <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                <Dialog.Title
                                  as="h3"
                                  className="text-lg leading-6 font-medium text-gray-900"
                                >
                                  Delete Payment
                                </Dialog.Title>
                                <div className="mt-2">
                                  <p className="text-sm text-gray-500">
                                    Are you sure you want to delete the Payment
                                    Details ?
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                              <button
                                type="button"
                                className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                                onClick={this.haldleDelete}
                              >
                                Delete
                              </button>
                              <button
                                type="button"
                                className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
                                onClick={() =>
                                  this.setState({ deletealartmsg: false })
                                }
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        </Transition.Child>
                      </div>
                    </Dialog>
                  </Transition.Root>
                  {/*End DeleteAlert */}

                  {/* /End replace */}
               
        </div>

        <div
          aria-live="assertive"
          className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
        >
          <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
            {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
            <Transition
              show={this.state.showmsg}
              //show={true}
              as={Fragment}
              enter="transform ease-out duration-300 transition"
              enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
              enterTo="translate-y-0 opacity-100 sm:translate-x-0"
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 mt-10">
                <div className="p-4">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      {this.state.icon ? (
                        <CheckCircleIcon
                          className="h-6 w-6 text-green-400"
                          aria-hidden="true"
                        />
                      ) : (
                        <XCircleIcon
                          className="h-6 w-6 text-red-400"
                          aria-hidden="true"
                        />
                      )}
                    </div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                      <p className="text-sm font-medium text-gray-900">
                        {this.state.message}
                      </p>
                      <p className="mt-1 text-sm text-gray-500"></p>
                    </div>
                    <div className="ml-4 flex-shrink-0 flex">
                      <button
                        className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        onClick={() => {
                          this.setState({ showmsg: false });
                        }}
                      >
                        <span className="sr-only">Close</span>
                        <XIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>
      </>
    );
  }
}

export default (props) => <Invoiceview {...props} params={useParams()} />;
